import React, { useEffect, useState } from "react";
import s from "./PanelDistribucionTelekino.module.css";
//assets
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Pager from "../../../Shared/Pagination/Pagination";
import EditableTelekino from "./Editable/EditableTelekino";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
//Material
import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import CircularProgress from "@mui/material/CircularProgress"
import LinearProgress from "@mui/material/LinearProgress"
import BallotIcon from "@mui/icons-material/Ballot";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import useTranslationException from "../../../../helpers/exceptions";
const centerGrid = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

// ====================== | PANEL DISTRIBUCION TELEKINO | ======================

const PanelDistribucionTelekino = ({ data, setEdicion, callFiles }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  //Estados
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  const [progress, setProgress] = useState(0);
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState({
    status: false,
    id: 0,
  });

  function simulateAsync(value) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, value);
    });
  }

  const performTasks = async () => {
    setProgress(0);
    setLoadingProgress(true);
    await simulateAsync(1000);

    for (let i = 0; i < 7; i++) {
      await simulateAsync(300);
      setProgress(((i + 1) / 7) * 100);
    }

    setProgress(100);
    masiveDistributionServices
      .postPreDistributionValidate(data.archive.id)
      .then(() => {
        setLoadingProgress(false);
        setEdicion({ status: false, archive: {} });
        return Swal.fire(
          t("finalizedDistribution"),
          t("archiveConfirmed"),
          "success",
        );
      })
      .then(() => callFiles())
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoadingProgress(false);
        setEdicion({ status: false, archive: {} });
      });
  };

  const handleConfirm = () => {
    Swal.fire({
      title: `${t("archiveConfirm")}: ${data.archive.id}`,
      text: `${t("archiveConfirmText")}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        performTasks();
      }
    });
  };

  const getData = () => {
    setLoading(true);
    masiveDistributionServices
      .getTelekinoItems(data.archive.id, page, pageSize)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [page, pageSize]);

  return (
    <Grid container className={s.container}>
      {loadingProgress ? (
        <Grid item container xs={12} sx={{ ...centerGrid, height: "600px" }}>
          <Grid item xs={10} className={s.linearprogress}>
            <LinearProgress variant="determinate" value={progress} />
            <p>{`${t("loadingDistConfirm")}: % ${progress.toFixed(1)}`}</p>
          </Grid>
        </Grid>
      ) : edit.status ? (
        <EditableTelekino
          getData={getData}
          id={edit.id}
          setEdit={setEdit}
          setItems={setItems}
          data={data}
          agencyFirstNumber={edit.agencyFirstNumber}
        />
      ) : (
        <>
          <Grid item container xs={11} className={s.header}>
            <Grid item xs={1} lg={1}>
              <ArrowBackIcon
                sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
                onClick={() => {
                  setEdicion({ status: false, archive: {} });
                  callFiles();
                }}
                className={s.arrow}
              />
            </Grid>
            <Grid item xs={11} lg={8} className={s.titleContainer}>
              <BallotIcon
                sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
              />
              <h4>{`${t("drawDetail")}: ${data?.archive?.raffleNumber}`}</h4>
            </Grid>
            {data.archive.status !== "Activo" &&
              <Grid item xs={12} lg={2} className={s.button}>
                <Button
                  variant="contained"
                  sx={{ width: "100%", height: "3.2rem" }}
                  onClick={handleConfirm}
                >
                  {t("confirm")}
                </Button>
              </Grid>
            }
          </Grid>

          <Grid item xs={11} className={s.data}>
            {loading ? (
              <Grid item xs={12} sx={{ ...centerGrid, height: "400px" }}>
                <CircularProgress size="3rem" />
              </Grid>
            ) : (
              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      align="center"
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("agencyNumber")}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >{`${t("coupon")} ${t("from").toLowerCase()}`}</TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >{`${t("coupon")} ${t("to").toLowerCase()}`}</TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >{`${t("quantity")} ${t("coupons").toLowerCase()}`}</TableCell>
                  </TableHead>
                  <TableBody>
                    {items?.map((item, i) => (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.nroDeAgencia
                              ? item.nroDeAgencia
                              : t("noSelectedAgency")}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.cuponDesde
                              ? item?.cuponDesde
                              : "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.cuponHasta
                              ? item?.cuponHasta
                              : "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item?.cantidadDeCupones
                              ? item?.cantidadDeCupones
                              : "-"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: "50px",
              }}
            >
              <Pager
                pageSize={pageSize}
                setPageSize={setPageSize}
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                pageCustom={pageCustom}
                setPageCustom={setPageCustom}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default PanelDistribucionTelekino;
